<template v-if="signatureVis">
  <div ref="signature" id="signature">
    <div id="canvas-control">
      <mt-button
        :disabled="control.disabled"
        :type="control.type"
        v-for="(control,index) in controls"
        :title="control.title"
        :class="control.className"
        @click.prevent="controlCanvas(control.action)"
        :key="index"
        size="small"
      >{{control.title}}</mt-button>
    </div>

    <div class="inner draw innerDraw" @mousemove="beginPath($event)">
      <div class="wrap">
        <canvas
          id="canvas"
          class="fl"
          :width="canWidth"
          :height="canHiehgt"
          @mousedown="canvasDown($event)"
          @mouseup="canvasUp($event)"
          @mousemove="canvasMove($event)"
          @touchstart="canvasDown($event)"
          @touchend="canvasUp($event)"
          @touchmove="canvasMove($event)"
        >你的浏览器不支持Canvas</canvas>
      </div>
    </div>
    <!--存放图片-->
    <!-- <div id="img-box" v-show="imgUrlList.length">
      <div class="img-item" v-for="(src,index) in imgUrlList" :key="index">
        <img :src="src" />
        <span class="fa fa-close" @click="removeImg(src)"></span>
      </div>
    </div>-->
    <!-- <img :src="imgUrl" alt="awaa" /> -->
    <footer>
      <mt-button type="primary" style="width:100%;" @click="confirmBtn">确定</mt-button>
    </footer>
    <img id="textImg" src alt />
    <!-- <button class="drawImage" @click="getImage()">预览</button> -->
  </div>
</template>

<script>
export default {
  props: {
    signatureVis: {
      type: Boolean
    },
    canvasWidth: {
      type: Number
    }
  },
  data() {
    return {
      canWidth: "600",
      canHiehgt: "375",
      colors: [
        "#fef4ac",
        "#0018ba",
        "#ffc200",
        "#f32f15",
        "#cccccc",
        "#5ab639"
      ],
      brushs: [
        {
          className: "small fa fa-paint-brush",
          lineWidth: 3
        },
        {
          className: "middle fa fa-paint-brush",
          lineWidth: 6
        },
        {
          className: "big fa fa-paint-brush",
          lineWidth: 12
        }
      ],
      context: {},
      imgUrlList: [],
      imgUrl: "",
      canvasMoveUse: true,
      // 存储当前表面状态数组-上一步
      preDrawAry: [],
      // 存储当前表面状态数组-下一步
      nextDrawAry: [],
      // 中间数组
      middleAry: [],
      // 配置参数
      config: {
        lineWidth: 1,
        // lineColor: "#f2849e",
        lineColor: "#000",
        shadowBlur: 2
      }
    };
  },
  mounted() {
    this.canWidth = this.canvasWidth;
    // console.log(this.canWidth)
    // this.canHiehgt = this.$refs.signature.offsetHeight;
    const canvas = document.querySelector("#canvas");
    this.context = canvas.getContext("2d");
    this.initDraw();
    this.setCanvasStyle();
  },
  computed: {
    controls() {
      return [
        {
          title: "上一步",
          action: "prev",
          type: "primary",
          disabled: !this.preDrawAry.length
        },
        {
          title: "下一步",
          action: "next",
          type: "primary",
          disabled: !this.preDrawAry.length || !this.nextDrawAry.length
        },
        {
          title: "清除",
          action: "clear",
          type: "danger",
          disabled: !this.preDrawAry.length
        }
      ];
    }
  },
  methods: {
    isPc() {
      const userAgentInfo = navigator.userAgent;
      const Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      ];
      let flag = true;
      for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    removeImg(src) {
      this.imgUrlList = this.imgUrlList.filter(item => item !== src);
    },
    initDraw() {
      const preData = this.context.getImageData(0, 0, this.canWidth, 375);
      // 空绘图表面进栈
      this.middleAry.push(preData);
    },
    canvasMove(e) {
      if (this.canvasMoveUse) {
        const t = e.target;
        let canvasX;
        let canvasY;
        if (this.isPc()) {
          canvasX = e.clientX - t.parentNode.offsetLeft;
          canvasY = e.clientY - t.parentNode.offsetTop;
        } else {
          canvasX = e.changedTouches[0].clientX - t.parentNode.offsetLeft;
          canvasY = e.changedTouches[0].clientY - t.parentNode.offsetTop;
        }
        this.context.lineTo(canvasX, canvasY);
        this.context.stroke();
      }
    },
    beginPath(e) {
      const canvas = document.querySelector("#canvas");
      if (e.target !== canvas) {
        this.context.beginPath();
      }
    },
    // mouseup
    canvasUp(e) {
      const preData = this.context.getImageData(0, 0, this.canWidth, 375);
      if (!this.nextDrawAry.length) {
        // 当前绘图表面进栈
        this.middleAry.push(preData);
      } else {
        this.middleAry = [];
        this.middleAry = this.middleAry.concat(this.preDrawAry);
        this.middleAry.push(preData);
        this.nextDrawAry = [];
      }
      this.canvasMoveUse = false;
    },
    // mousedown
    canvasDown(e) {
      this.canvasMoveUse = true;
      // client是基于整个页面的坐标
      // offset是cavas距离顶部以及左边的距离
      const canvasX = e.clientX - e.target.parentNode.offsetLeft;
      const canvasY = e.clientY - e.target.parentNode.offsetTop;
      this.setCanvasStyle();
      // 清除子路径
      this.context.beginPath();
      this.context.moveTo(canvasX, canvasY);
      // 当前绘图表面状态
      const preData = this.context.getImageData(0, 0, this.canWidth, 375);
      // 当前绘图表面进栈
      this.preDrawAry.push(preData);
    },
    // 设置颜色
    setColor(color) {
      this.config.lineColor = color;
    },
    // 设置笔刷大小
    setBrush(type) {
      this.config.lineWidth = type;
    },
    // 操作
    controlCanvas(action) {
      switch (action) {
        case "prev":
          if (this.preDrawAry.length) {
            const popData = this.preDrawAry.pop();
            const midData = this.middleAry[this.preDrawAry.length + 1];
            this.nextDrawAry.push(midData);
            this.context.putImageData(popData, 0, 0);
          }
          break;
        case "next":
          if (this.nextDrawAry.length) {
            const popData = this.nextDrawAry.pop();
            const midData = this.middleAry[
              this.middleAry.length - this.nextDrawAry.length - 2
            ];
            this.preDrawAry.push(midData);
            this.context.putImageData(popData, 0, 0);
          }
          break;
        case "clear":
          this.context.clearRect(
            0,
            0,
            this.context.canvas.width,
            this.context.canvas.height
          );
          this.preDrawAry = [];
          this.nextDrawAry = [];
          this.middleAry = [this.middleAry[0]];
          break;
      }
    },
    // 生成图片
    getImage() {
      const canvas = document.querySelector("#canvas");
      const src = canvas.toDataURL("image/png");
      // console.log(src)
      this.imgUrl = src;
      this.imgUrlList.push(src);
      if (!this.isPc()) {
        // window.open(`data:text/plain,${src}`)
        window.location.href = src;
      }
    },
    // 设置绘画配置
    setCanvasStyle() {
      this.context.lineWidth = this.config.lineWidth;
      this.context.shadowBlur = this.config.shadowBlur;
      this.context.shadowColor = this.config.lineColor;
      this.context.strokeStyle = this.config.lineColor;
    },
    // 将base64转换成file对象
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(",");
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      //转换成file对象
      // return new File([u8arr], filename, { type: mime });
      //转换成成blob对象
      return new Blob([u8arr], { type: mime });
    },
    //确定按钮
    confirmBtn() {
      let canvas = document.querySelector("#canvas");
      // let context = canvas.getContext("2d");
      const canvasSrc = canvas.toDataURL("image/png", 1);

      this.$emit("signatureObj", {
        signatureVal: false,
        upImgUrl: canvasSrc
      });
    }
  }
};
</script>

<style scope>
@media screen and (max-width: 700px) {
  #img-box,
  #canvas-drawImage h5,
  #canvas-brush {
    display: none;
  }
  #canvas-drawImage button {
    width: auto;
    position: absolute;
    flex: 1;
  }
  .wrap #control {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;
    text-align: center;
  }
}

#signature {
  width: 100%;
  height: 50%;
  /* position: fixed; */
  /* top: 0; */
  /* left: 0; */
  touch-action: none;
}
.innerDraw {
  touch-action: none;
  padding: 2vw;
}

.fix-body {
  position: fixed !important;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
}
.inner.draw {
  display: flex;
  flex-direction: row;
}
.draw h5 {
  margin-bottom: 10px;
}
#img-box {
  flex: 1;
  padding-left: 10px;
}
#img-box .img-item {
  position: relative;
  display: inline-block;
}
#img-box .img-item .fa {
  position: absolute;
  cursor: pointer;
  right: 1px;
  top: -1px;
  font-size: 12px;
  font-weight: 1;
  display: none;
  color: #ccc;
}
#img-box .img-item:hover .fa {
  display: block;
}
#img-box .img-item .fa:hover {
  /* color: #f2849e; */
  color: #000;
}
#img-box img {
  border: 1px #ccc solid;
  width: 90px;
  height: 60px;
  margin: 5px;
}
.wrap {
  width: 740px;
  overflow: hidden;
  /* border-radius: 4px; */
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.fl {
  float: left;
  display: block;
}
#canvas {
  cursor: crosshair;
}
#control {
  width: 130px;
  height: 400px;
  margin-left: 4px;
}
#control div {
  padding: 5px;
}
#canvas-color ul {
  overflow: hidden;
  margin: 0;
  padding: 0;
}
#canvas-color ul li {
  float: left;
  display: inherit;
  width: 13px;
  height: 13px;
  border: 3px #fff solid;
  margin: 8px;
  cursor: pointer;
}
#canvas-color .active {
  /* border: 1px solid #f2849e; */
  border: 1px solid #000;
}
#canvas-brush span {
  display: inline-block;
  width: 20px;
  height: 15px;
  margin-left: 10px;
  cursor: pointer;
}
#canvas-brush .small {
  font-size: 12px;
}
#canvas-brush .middle {
  font-size: 14px;
}
#canvas-brush .big {
  font-size: 16px;
}

#canvas-control {
  display: flex;
  justify-content: start;
  box-sizing: border-box;
  padding: 4vw 0;
  border-radius: 1vw;
}

#canvas-control button {
  display: inline-block;
  margin-left: 10px;
  cursor: pointer;
}
#canvas-control .active,
#canvas-brush .active {
  /* color: red; */
}
.drawImage {
  width: 100px;
  height: 30px;
  font-size: 12px;
  line-height: 30px;
}

footer {
  padding: 0 2vw;
  box-sizing: border-box;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/signature.vue